import { useCallback, useContext, useState } from "react";
import { SuccessAlertContext } from "App";
import settingCompanyDataApi from "../api/settingCompanyDataApi";
import type { SaveCompanySettingParams } from "../types";
import type { Severity } from "../../../type/index";

/**
 * ジョイフル企業用登録、更新、削除hooks
 */
export default function useCompanySetting() {
  const [isRegistering, setIsRegistering] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const { showAlert } = useContext(SuccessAlertContext);

  const registerCompany = useCallback(
    async (params: Omit<SaveCompanySettingParams, "operation">) => {
      const body: SaveCompanySettingParams = {
        operation: 0,
        ...params,
      };

      setIsRegistering(true);
      try {
        const status = await settingCompanyDataApi(body);
        // 登録成功提示;
        showAlert("登録しました。", "success");
      } catch (err) {
        showAlert("登録に失敗しました。", "error" as Severity);
        console.error(err);
        throw err;
      } finally {
        setIsRegistering(false);
      }
    },
    [showAlert],
  );

  const updateCompany = useCallback(async (params: Omit<SaveCompanySettingParams, "operation">) => {
    const body: SaveCompanySettingParams = {
      operation: 1,
      ...params,
    };

    setIsUpdating(true);

    try {
      const status = await settingCompanyDataApi(body);
      // 更新成功提示
      showAlert("更新しました。", "success");
      return status;
    } catch (err) {
      showAlert("更新に失敗しました。", "error" as Severity);
      throw err;
    } finally {
      setIsUpdating(false);
    }
  }, []);

  const deleteCompany = useCallback(async (company_cd: string) => {
    const body: SaveCompanySettingParams = {
      operation: 9,
      company_cd,
      // center_cd: "",
      // stores: [],
    };

    setIsDeleting(true);
    try {
      const status = await settingCompanyDataApi(body);
      // 削除成功提示
      showAlert("削除しました。", "success");
      setIsDeleting(false);
      return status;
    } catch (err) {
      showAlert("削除に失敗しました。", "error" as Severity);
      throw err;
    } finally {
      setIsDeleting(false);
    }
  }, []);

  return {
    isRegistering,
    isUpdating,
    isDeleting,
    setIsRegistering,
    registerCompany,
    updateCompany,
    deleteCompany,
  };
}
